import { GetterTree } from 'vuex'
import { RootState } from '@/store/types'
import { SmartMeterConnectionState } from './types';

export const getters: GetterTree<SmartMeterConnectionState, RootState> = {}
